import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center justify-content-between position-relative" }
const _hoisted_2 = {
  class: "chart-position for-sale",
  style: {"right":"-10px","top":"-30px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "mb-3" }, [
        _createElementVNode("span", { class: "fs-14" }, "New Registers"),
        _createElementVNode("h3", { class: "fs-20 mb-0" }, "35.3k")
      ], -1)),
      _createElementVNode("div", _hoisted_2, [
        (_ctx.isClient)
          ? (_openBlock(), _createBlock(_component_apexchart, {
              key: 0,
              type: "area",
              height: "95",
              options: _ctx.newRegisters,
              series: _ctx.registers
            }, null, 8, ["options", "series"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "d-flex align-items-center justify-content-between position-relative mt-1" }, [
      _createElementVNode("span", { class: "d-inline-block bg-success bg-opacity-10 text-success px-2 border border-success rounded-pill fs-12 fw-medium" }, " +15% Increase "),
      _createElementVNode("span", { class: "fs-12" }, "Last 7 days")
    ], -1))
  ]))
}